import {
  getTicketGetQueryKey,
  getTicketListQueryKey,
  getTicketMessageListQueryKey,
  ticketAddProgress,
  ticketCommentDelete,
  ticketCommentUpdate,
  ticketCreate,
  ticketDelete,
  ticketGet,
  ticketList,
  ticketMessageCreate,
  ticketMessageDelete,
  ticketMessageList,
  ticketReadMessage,
  ticketUpdate,
  useTicketAddProgress,
  useTicketCommentDelete,
  useTicketCommentUpdate,
  useTicketCreate,
  useTicketDelete,
  useTicketGet,
  useTicketGetSuspense,
  useTicketList,
  useTicketListSuspense,
  useTicketMessageCreate,
  useTicketMessageDelete,
  useTicketMessageList,
  useTicketMessageListSuspense,
  useTicketReadMessage,
  useTicketUpdate,
} from "@/api/generated/endpoints/api"
import {
  // Ticket CRUD schemas
  ticketAddProgressBody,
  ticketCommentUpdateBody,
  ticketCreateBody,
  ticketDeleteParams,
  ticketDeleteResponse,
  ticketGetParams,
  // Response schemas
  ticketGetResponse,
  ticketListQueryParams,
  ticketUpdateBody,
  ticketUpdateResponse,
} from "@/api/generated/schemas/api.zod"

// API hooks and functions
export const ticketApi = {
  // Query hooks
  useTicketGet,
  useTicketGetSuspense,
  useTicketList,
  useTicketListSuspense,

  // Mutation hooks
  useTicketCreate,
  useTicketUpdate,
  useTicketDelete,

  // Direct API functions
  ticketGet,
  ticketList,
  ticketCreate,
  ticketUpdate,
  ticketDelete,

  // Query key getters
  getTicketGetQueryKey,
  getTicketListQueryKey,

  // Comment API hooks
  useTicketCommentDelete,
  useTicketCommentUpdate,

  // Comment Direct API functions
  ticketCommentDelete,
  ticketCommentUpdate,

  // Message API hooks
  useTicketMessageList,
  useTicketMessageListSuspense,
  useTicketMessageCreate,
  useTicketMessageDelete,

  // Message Direct API functions
  ticketMessageList,
  ticketMessageCreate,
  ticketMessageDelete,

  // Message Query key getters
  getTicketMessageListQueryKey,

  // Progress API hooks
  useTicketAddProgress,

  // Progress Direct API functions
  ticketAddProgress,

  // Read Message API hooks
  useTicketReadMessage,

  // Read Message Direct API functions
  ticketReadMessage,
}

export const ticketSchemas = {
  // Ticket CRUD schemas
  ticketAddProgressBody,
  ticketCommentUpdateBody,
  ticketCreateBody,
  ticketDeleteParams,
  ticketDeleteResponse,
  ticketGetParams,
  ticketUpdateBody,

  // Response schemas
  ticketGetResponse,
  ticketListQueryParams,
  ticketUpdateResponse,
}

export * as TicketModels from "./models"
